
import React, { useState, useEffect, useRef, useCallback } from "react";
import { ChevronUp } from "lucide-react";
import { useAPI } from "../Context/MyContext";
import Message from "./Message";
import { normalizeDate } from "../utils/helpingFuntions";

const MessageChat = ({ phoneId, recipientId, recipientName = "Contact", totalUnread, setIsAllowedToSendMessage, setCswStatus, messageID }) => {
  const [messages, setMessages] = useState([]);
  const [lastMessage, setLastMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [cursor, setCursor] = useState(null);
  const [error, setError] = useState(null);
  const { getRecipientMessages, socket, fetchCSWStatus } = useAPI();
  const getDateKey = (dateString) => {
    const d = new Date(dateString);
    return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
  };

  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true)

  const formatDateBadge = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

    const diffDays = Math.floor((today - date) / (1000 * 60 * 60 * 24));
    if (diffDays < 7) {
      return date.toLocaleDateString([], { weekday: "long" }); // "Friday", "Saturday"
    }

    return date.toLocaleDateString([], { day: "numeric", month: "long", year: "numeric" });
  };
  // console.log("messages are:", messages)
  // console.log("recipientId", recipientId)
  const markUnreadAsRead = () => {
    // console.log("Socket marking as read called");
    // console.log("messages are ",messages)

    // const unread = messages.filter(
    //   (msg) => msg.direction === "received" && msg.status !== "read"
    // );

    // if (unread.length === 0) return;
    if (totalUnread === 0) return;



    socket.emit("chat:read", {
      phone_number_id: phoneId,
      recipient_id: recipientId,

      // message_ids: unread.map((m) => m.message_id)
    });

    // console.log("Socket mark",
    //   recipientId,
    //   phoneId,
    // )


  };
  useEffect(() => {
    if (recipientId) markUnreadAsRead();
  }, [messages]);


  // ===========================================================
  // 🔹 Fetch messages (initial + pagination)
  // ===========================================================
  const fetchMessages = useCallback(
    async (cursorParam = null, isLoadMore = false) => {
      try {
        if (isLoadMore) setLoadingMore(true);
        else {
          setLoading(true);
          setError(null);
        }
        
        // const params = new URLSearchParams({
        //   recipient: recipientId,
        //   limit: "20",
        // });

        const params = new URLSearchParams({
          recipient: messageID,
          limit: "20",
        });
        if (cursorParam) params.append("cursor", cursorParam);

        const response = await getRecipientMessages(phoneId, params);
        const fetchedMessages = response.items || [];
        try {
          // const cswStatus = await fetchCSWStatus(phoneId, recipientId);
          const cswStatus = await fetchCSWStatus(phoneId, messageID);
          setCswStatus(cswStatus);
          // console.log("CSW Status:", cswStatus);
        } catch (error) {
          console.error("Error fetching CSW status:", error);
        }

        // fetchCSWStatus
        if (isLoadMore) {
          setMessages((prev) => [...fetchedMessages, ...prev]);
        } else {
          // setMessages(fetchedMessages);

          // // console.log("fetchMessages.type:",  fetchedMessages.map(m => m.type));
          // const last_message = fetchedMessages[fetchedMessages.length - 1];
          // const second_last_message = fetchedMessages[fetchedMessages.length - 2];
          // const date_normalized = normalizeDate(last_message.createdAt);
          // console.log("Last message  normalized:", last_message);
          // console.log("Last message date normalized:", date_normalized);
          // // console.log("Last message in fetch:", lastMessage.type);
          // // if direction is sent and type is template and template is sent within  24 hours then block sending message
          // if (last_message.type === "template" && last_message.direction === "sent" && date_normalized < 24 * 60 * 60 * 1000) {
          //   setIsAllowedToSendMessage(false);
          //   setLastMessage(last_message)
          // }
          // // if direction is sent and type is template and template is sent more than  24 hours then block sending message
          // else if (last_message.type !== "template" && second_last_message.direction === "sent " && date_normalized > 24 * 60 * 60 * 1000 ) {
          //   setLastMessage(last_message)
          //   setIsAllowedToSendMessage(false);
          // }

          setMessages(fetchedMessages);

          if (!fetchedMessages.length) return;

          const lastMessage = fetchedMessages[fetchedMessages.length - 1];

          const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

          // Convert createdAt → timestamp
          const lastMessageTime = new Date(lastMessage.createdAt).getTime();
          const now = Date.now();

          // Time difference in ms
          const timeSinceLastMessage = now - lastMessageTime;

          // console.log("Last message createdAt:", lastMessage.createdAt);
          // console.log("Time since last message (ms):", timeSinceLastMessage);

          // ✅ BLOCK ONLY THIS CASE
          const shouldBlock =
            lastMessage.type === "template" &&
            lastMessage.direction === "sent" &&
            timeSinceLastMessage < TWENTY_FOUR_HOURS;

          if (shouldBlock) {
            setIsAllowedToSendMessage(true);
            setLastMessage(lastMessage);
            // console.log("🚫 Blocked: Template sent within last 24 hours");
          } else {
            setIsAllowedToSendMessage(true);
            setLastMessage(lastMessage);
            // console.log("✅ Allowed: Can send message");
          }


          // ================= ALLOWED =================
          // else {
          //   setIsAllowedToSendMessage(false);
          //   console.log("✅ Allowed to send message");
          // }


          // setMessages(fetchedMessages);

          // const now = Date.now();
          // const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

          // // Get last received (user) message
          // const lastUserMessage = [...fetchedMessages]
          //   .reverse()
          //   .find(msg => msg.direction === "received");
          // console.log("Last user message:", lastUserMessage);
          // if (!lastUserMessage) {
          //   // ❌ No user message ever → only templates allowed
          //   setIsAllowedToSendMessage(false);
          //   return; 
          // }

          // const lastUserMessageTime = new Date(lastUserMessage.createdAt).getTime();
          // const isWithin24Hours = now - lastUserMessageTime <= TWENTY_FOUR_HOURS;

          // if (isWithin24Hours) {
          //   // ✅ User-initiated window is open
          //   setIsAllowedToSendMessage(true);
          // } else {
          //   // ❌ Window expired → only templates allowed
          //   setIsAllowedToSendMessage(false);
          // }
          // setLastMessage(lastUserMessage);

          setTimeout(scrollToBottom, 100);
        }

        setCursor(response.nextCursor || null);
        setHasMore(response.hasMore || false);
      } catch (err) {
        console.error("Error fetching messages:", err);
        setError(err.message || "Failed to load messages");
      } finally {
        setLoading(false);
        setLoadingMore(false);
      }
    },
    [phoneId, recipientId, getRecipientMessages]
  );

  useEffect(() => {
    if (recipientId) {
      setMessages([]);
      setCursor(null);
      setHasMore(true);
    }
  }, [recipientId]);

  // ===========================================================
  // 🔹 Load on chat change
  // ===========================================================
  useEffect(() => {
    if (phoneId && recipientId) {
      fetchMessages();
    }
  }, [phoneId, recipientId, fetchMessages]);

  // ===========================================================
  // 🔹 Socket message handling
  // ===========================================================
  useEffect(() => {
    if (!socket) return;

    const handleIncomingMessage = (data) => {
      // console.log("📡 Message received:", data);

      // Append only if message belongs to the open chat
      if (
        data.recipient_id === recipientId ||
        data.sender_id === recipientId
      ) {
        setMessages((prev) => [...prev, data]);
        // console.log("✅ Appended to current chat:", recipientId);
      } else {
        // console.log("⚠️ Ignored (belongs to another chat):", data.recipient_id);
        // (Optional) trigger global notification or unread counter here
      }
    };

    const handleSendMessage = (payload) => {
      // console.log("📩 Outgoing (send-message):", payload);
      if (
        payload.recipient_id === recipientId ||
        payload.sender_id === recipientId
      ) {
        setMessages((prev) => [...prev, payload]);
      }
    };




    socket.on("message:received", handleIncomingMessage);
    socket.on("send-message", handleSendMessage);

    return () => {
      socket.off("message:received", handleIncomingMessage);
      socket.off("send-message", handleSendMessage);
    };
  }, [socket, recipientId]);

  // ===========================================================
  // 🔹 Scroll behavior
  // ===========================================================
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (isAtBottom) scrollToBottom();
  }, [messages]);

  const handleScroll = () => {
    const container = messagesContainerRef.current;
    if (!container) return;
    const { scrollTop, scrollHeight, clientHeight } = container;
    setIsAtBottom(scrollHeight - scrollTop - clientHeight < 50);
  };

  const loadMoreMessages = () => {
    if (cursor && hasMore && !loadingMore) fetchMessages(cursor, true);
  };

  // ===========================================================
  // 🔹 UI
  // ===========================================================
  if (loading && messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="flex flex-col items-center gap-4">

          {/* Premium Loader */}
          <div className="relative flex items-center justify-center">

            {/* Outer Ring */}
            <div className="w-8 h-8 border-4 border-gray-200 rounded-full"></div>

            {/* Spinning Ring */}
            <div className="absolute w-8 h-8 border-4 border-transparent border-t-[#008069] border-r-[#008069] rounded-full animate-spin"></div>

            {/* Center Dot */}
            {/* <div className="absolute w-3 h-3 bg-[#008069] rounded-full animate-pulse"></div> */}

          </div>

          {/* Text */}
          <span className="text-sm text-gray-600 font-medium tracking-wide">
            Loading messages...
          </span>

        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <p className="text-red-600 mb-2">Error loading messages</p>
          <p className="text-gray-600 text-sm">{error}</p>
          <button
            onClick={() => fetchMessages()}
            className="mt-3 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      onScroll={handleScroll}
      className="flex-1 overflow-y-auto p-4 z-10"
      ref={messagesContainerRef}
    >
      {hasMore && (
        <div className="text-center">
          <button
            onClick={loadMoreMessages}
            disabled={loadingMore}
            className="px-4 py-2 text-sm bg-white border border-gray-300 rounded-full hover:bg-gray-50 disabled:opacity-50 flex items-center mx-auto space-x-2"
          >
            {loadingMore ? (
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
            ) : (
              <ChevronUp className="w-4 h-4" />
            )}
            <span>{loadingMore ? "Loading..." : "Load older messages"}</span>
          </button>
        </div>
      )}

      {messages.length === 0 ? (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">
            No messages yet. Start the conversation!
          </p>
        </div>
      ) : (
        [...messages]
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          .map((message, index, arr) => {
            const currentDate = getDateKey(message.createdAt);
            const prevDate = index > 0 ? getDateKey(messages[index - 1].createdAt) : null;
            const showBadge = currentDate !== prevDate;

            return (
              <React.Fragment key={message._id || message.id}>
                {showBadge && (
                  <div className="flex justify-center my-3">
                    <span className="bg-gray-100 text-[#54656f] text-[12px] font-medium px-3 py-1 rounded-full shadow-sm">
                      {formatDateBadge(message.createdAt)}
                    </span>
                  </div>
                )}
                <Message
                  message={message}
                  setMessages={setMessages}
                  phoneId={phoneId}
                />
              </React.Fragment>
            );
          })
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageChat;
